import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    thumbFrame: {
      cursor: 'pointer',
      [theme.fn.smallerThan('sm')]: {
        width: '100%',
      },
      flexGrow: 1,
      '&, img': {
        borderRadius: 8,
      },
    },
    img: {
      display: 'block',
    },
  }
})
